import { useEmitLocationShare } from "./useEmitLocationShare";
import { useReceivedLocationShare } from "./useReceivedLocationShare";

const useLocationShare = () => {
  useReceivedLocationShare();
  useEmitLocationShare();
};

export default useLocationShare;
